"use client";

import React, { createContext, useContext } from "react";
import type { Socket } from "socket.io-client";
import { useSocket } from "@/hooks/useSocket";

type SocketContextValue = {
  socketRef: React.RefObject<Socket | null>;
  isConnected: boolean;
};

const SocketContext = createContext<SocketContextValue | undefined>(undefined);

export function SocketProvider({ children }: { children: React.ReactNode }) {
  const { socketRef, isConnected } = useSocket();

  return (
    <SocketContext.Provider value={{ socketRef, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocketContext(): SocketContextValue {
  const ctx = useContext(SocketContext);
  if (!ctx) {
    throw new Error("useSocketContext must be used within SocketProvider");
  }
  return ctx;
}
